import {
  AD_FRAUD_COOKIE_NAME,
  AD_FRAUD_ORIGIN_HASH_COOKIE_NAME,
  VISITOR_COOKIE_NAME,
} from '../constants';
import { CookieUtils } from '../types/cookies_utils';
import Identifier from './identifiers';

class AdFraudDetection {
  constructor(
    private readonly identifier: Identifier,
    private readonly cookieUtils: CookieUtils,
  ) {}

  getAdFraudDetectionId() {
    const hasVisitorId = !!this.cookieUtils.getCookie(VISITOR_COOKIE_NAME);
    // This does nothing if valid vi cookie has been set already
    this.identifier.authorizeIdentifier(AD_FRAUD_COOKIE_NAME, hasVisitorId);

    return this.cookieUtils.getCookie(AD_FRAUD_COOKIE_NAME);
  }

  getAdFraudDetectionIdOriginHash() {
    const cookie = this.cookieUtils.getCookie(AD_FRAUD_ORIGIN_HASH_COOKIE_NAME);

    return cookie && decodeURIComponent(cookie);
  }

  checkResetAdFraudDetectionId(userId: string) {
    return this.identifier.checkResetIdentifier(
      userId,
      AD_FRAUD_ORIGIN_HASH_COOKIE_NAME,
      AD_FRAUD_COOKIE_NAME,
    );
  }
}

export default AdFraudDetection;
